import type { ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { CarryDocumentStatusBadge } from '@/components/carry-documents/CarryDocumentStatusBadge';
import { formatDocumentDate } from '@/components/carry-documents/carryDocumentStatus';
import type { CarryDocument } from '../services/carryService';

interface CarryDocumentDetailsDialogProps {
  document: CarryDocument;
  fundName: string;
  holderName: string;
  onClose: () => void;
}

function Detail({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="grid grid-cols-3 gap-4 py-2">
      <dt className="text-sm text-muted-foreground">{label}</dt>
      <dd className="col-span-2 text-sm text-foreground">{value}</dd>
    </div>
  );
}

export function CarryDocumentDetailsDialog({
  document,
  fundName,
  holderName,
  onClose,
}: CarryDocumentDetailsDialogProps) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[520px]">
        <DialogHeader>
          <DialogTitle>{document.title}</DialogTitle>
          <DialogDescription>{fundName}</DialogDescription>
        </DialogHeader>
        <dl className="divide-y">
          <Detail label="Type" value={document.document_type.name} />
          <Detail
            label="Status"
            value={<CarryDocumentStatusBadge status={document.status} />}
          />
          <Detail label="Holder" value={holderName} />
          <Detail
            label="Date"
            value={formatDocumentDate(document.document_date)}
          />
          <Detail
            label="File"
            value={
              document.has_file ? 'Available to download' : 'Not uploaded yet'
            }
          />
        </dl>
      </DialogContent>
    </Dialog>
  );
}
